__turbopack_context__.v({
  "Cpart-2": "Footer-module__S6Hkya__Cpart-2",
  "Cpart1": "Footer-module__S6Hkya__Cpart1",
  "Cpart2": "Footer-module__S6Hkya__Cpart2",
  "buttonBoxDestopBtn": "Footer-module__S6Hkya__buttonBoxDestopBtn",
  "buttonBoxMobileBtn": "Footer-module__S6Hkya__buttonBoxMobileBtn",
  "copyRight": "Footer-module__S6Hkya__copyRight",
  "copyRightDiv": "Footer-module__S6Hkya__copyRightDiv",
  "desktopInputHeight": "Footer-module__S6Hkya__desktopInputHeight",
  "footHead": "Footer-module__S6Hkya__footHead",
  "footer": "Footer-module__S6Hkya__footer",
  "footerDiv": "Footer-module__S6Hkya__footerDiv",
  "footerInfo": "Footer-module__S6Hkya__footerInfo",
  "footerParent": "Footer-module__S6Hkya__footerParent",
  "headImage": "Footer-module__S6Hkya__headImage",
  "inlineItem": "Footer-module__S6Hkya__inlineItem",
  "inlineList": "Footer-module__S6Hkya__inlineList",
  "list": "Footer-module__S6Hkya__list",
  "mobileInputHeight": "Footer-module__S6Hkya__mobileInputHeight",
  "part1": "Footer-module__S6Hkya__part1",
  "part2": "Footer-module__S6Hkya__part2",
  "part3": "Footer-module__S6Hkya__part3",
  "siteName": "Footer-module__S6Hkya__siteName",
});
